/*
 * Adds a "Share" control to the product detail modal, next to the existing
 * wishlist star — clicking it copies a real, working link straight to that
 * one item (assets/sat-deeplink-patch.js's `#item/<code>` route) to the
 * clipboard, so a link built here can actually be pasted somewhere off-site
 * and land a visitor directly on that product, size picker and all.
 *
 * Wraps SATComponent.prototype.renderVals (same technique as the other
 * sat-*-patch.js files). Builds the URL straight from `detail.id` rather
 * than reading it back off _hashFor/location.hash — the detail modal is a
 * full-screen overlay any time it's open, so its own id is always the
 * correct link regardless of whatever page sits underneath it.
 *
 * Clipboard write is best-effort with a plain-textarea fallback for any
 * browser/context where navigator.clipboard isn't available (e.g. non-
 * secure context) — either path flips the icon to a checkmark for 1.6s as
 * confirmation, the same "flash and revert" pattern the ad-block toggle in
 * snippets/sat-term-90s.liquid already uses.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    } catch (e) {
      return false;
    }
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;

    if (!out.detail) { return out; }

    var detailId = out.detail.id;
    var copied = s.shareCopiedFor === detailId;

    out.detail = Object.assign({}, out.detail, {
      shareIcon: copied ? '✓' : '↗',
      shareColor: copied ? '#F0C77A' : '#a89a83',
      shareTitle: copied ? 'Link copied' : 'Copy link to this item',
      copyShareLink: function () {
        var url = location.origin + location.pathname + '#item/' + detailId;
        copyText(url).then(function () {
          self.siteTone && self.siteTone('g', 0.04);
          self.setState({ shareCopiedFor: detailId });
          setTimeout(function () {
            self.setState(function (st) {
              return st.shareCopiedFor === detailId ? { shareCopiedFor: null } : {};
            });
          }, 1600);
        });
      }
    });

    return out;
  };
})();
